module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "preview",
    class: _vm.classes
  }, [_c('router-link', {
    staticClass: "preview__link",
    attrs: {
      "to": _vm.link
    }
  }, [(_vm.post.image) ? _c('img', {
    staticClass: "preview__img",
    attrs: {
      "src": _vm.image,
      "alt": _vm.post.image.alt
    }
  }) : _vm._e()]), _vm._v(" "), _c('router-link', {
    staticClass: "preview__content",
    attrs: {
      "to": _vm.link
    }
  }, [_c('router-link', {
    attrs: {
      "to": ("/blogue/categorie/" + (_vm.post.category))
    }
  }, [_c('icon', {
    class: ("preview__icon preview__icon--" + (_vm.post.category)),
    attrs: {
      "id": _vm.post.category
    }
  })], 1), _vm._v(" "), _c('h3', {
    staticClass: "preview__title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), (_vm.featured) ? _c('p', [_vm._v(_vm._s(_vm.getExcerpt()))]) : _vm._e(), _vm._v(" "), _c('p', {
    class: ("preview__cat preview__cat--" + (_vm.post.category))
  }, [_vm._v(_vm._s(_vm.cat))])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6d5270e0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/blog/PostPreview.vue
// module id = 641
// module chunks = 1